import {OrderType} from "../../shared-types/orderDefinitions";

export function translateOrderType(type: OrderType): string {
  if(type === "operationalAndMaintenanceSla") return "SLA";
  else return type;
}
